import { render } from "./SSLCertificateTab.vue?vue&type=template&id=56310157&scoped=true"
import script from "./SSLCertificateTab.vue?vue&type=script&lang=js"
export * from "./SSLCertificateTab.vue?vue&type=script&lang=js"

import "./SSLCertificateTab.vue?vue&type=style&index=0&id=56310157&scoped=true&lang=css"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56310157"]])

export default __exports__